import { useMemo } from "react";

import type { ClaimWithRelations } from "../api/use-claim";
import { type ClaimMachineSnapshot, getAvailableEvents, replayClaimEvents } from "./replay-claim-events";

export interface ClaimMachineState {
  snapshot: ClaimMachineSnapshot | null;
  availableEvents: string[];
}

/** Machine state + available actions for a claim — mirrors ClaimStore.machineState. */
export function useClaimMachine(claim: ClaimWithRelations | undefined): ClaimMachineState {
  return useMemo(() => {
    if (!claim) {
      return { snapshot: null, availableEvents: [] };
    }

    const snapshot = replayClaimEvents({
      litigationName: claim.machine.litigationName,
      versionNumber: claim.machine.versionNumber,
      eventNames: claim.claimEvents.map((claimEvent) => claimEvent.eventType.displayName),
    });

    return { snapshot, availableEvents: getAvailableEvents(snapshot) };
  }, [claim]);
}
